import {GraphQLClient} from 'graphql-request'

import {hasuraAdminSecretHeaderField} from './constants/http'
import {getSdk} from './graphqlSdk'

// currently intended to be used from server-side only
// but nothing prevents us from using it client-side once user level role exists
export const client = getSdk(
  new GraphQLClient(process.env.GQL_BUILD_ENDPOINT ?? process.env.GQL_BE_ENDPOINT, {
    // don't send the x-hasura-admin-secret header if we don't have it
    // currently does not matter much, in the future this is how we'll configure the user-role
    headers: process.env.HASURA_ADMIN_SECRET
      ? {[hasuraAdminSecretHeaderField]: process.env.HASURA_ADMIN_SECRET}
      : {},
  }),
)
